import React from "react";
import { useNavigate } from "react-router-dom";
import RegistrationCertificationscomponents from "./RegistrationCertificationscomponents";
import CallToAction from "./CallToAction";

const RegistrationCertificationsInfo = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="other-pages-main-section registration-certifications-fin">
                <h2 className="other-pages-title">Registration and Certifications</h2>
                <p>
                    <span onClick={() => navigate("/")} style={{ cursor: "pointer" }}>Home</span> /
                    <span onClick={() => navigate("/registration-certifications")} style={{ cursor: "pointer" }}>Registration and Certifications</span>
                </p>
            </div>
            <RegistrationCertificationscomponents />
            <CallToAction />
        </>
    );
};

export default RegistrationCertificationsInfo;
